import * as React from 'react';
import cN from 'classnames';
import { useMediaQuery } from 'react-responsive';
import { LightBox, Button } from '@lion-design/core';
import * as Icons from '@components/Common/Icons';
import styles from '../styles.module.scss';

interface Option {
    text: string;
    value: string;
}

interface SwitchBtnProps {
    defaultSelect: string;
    options: Option[];
    onSwitched: (value: string) => void; // 之後有卡牌功能時用
}
const SwitchBtn: React.FC<SwitchBtnProps> = ({ defaultSelect, options, onSwitched }) => {
    const moduleName = 'switchBtn';
    // const defaultOption = options.filter((item) => item.value !== defaultSelect);
    const [selected, setSelected] = React.useState<Option>(options[1]);
    // const anotherOption = options.filter((item) => item.value !== selected.value);
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });
    const controlLightBox = (listStyle: Option) => () => {
        setSelected(() => listStyle);
    };

    // 是否把index的props 跟store狀態移到components -> 之後更動狀態在查詢上可能不適那麼直觀
    return (
        <>
            <LightBox
                closeBtn={false}
                open={selected.value === 'Cards'}
                ToggleLightBox={() => setSelected(options[1])}
            >
                <div className={styles.lightboxContent}>
                    <h3 className={styles.lightboxContent_title}>謝謝您對這功能感興趣</h3>
                    <p className={styles.lightboxContent_content}>
                        目前還沒有切換卡牌顯示的功能，但您的意見會成為我們改進的動力！
                    </p>
                    <Button className="continue" onClick={() => setSelected(options[1])}>
                        繼續瀏覽
                    </Button>
                </div>
            </LightBox>
            {isMobile ? (
                <div onClick={controlLightBox(options[0])}>
                    <Icons.RowList fill="#f03742" />
                </div>
            ) : (
                options.map((listStyle) => (
                    <div
                        key={listStyle.text}
                        className={styles[`${moduleName}`]}
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={controlLightBox(listStyle)}
                    >
                        {listStyle.value === 'Cards' ? (
                            <Icons.Brick />
                        ) : (
                            <Icons.RowList fill="#f03742" />
                        )}
                        <span
                            className={cN(styles[`${moduleName}_text`], {
                                active: listStyle.value === 'List',
                            })}
                            onMouseDown={(e) => e.preventDefault()}
                        >
                            {listStyle.text}
                        </span>
                    </div>
                ))
            )}
        </>
    );
};

export default SwitchBtn;
